import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=5c24acd4&scoped=true"
import script from "./Cooperate.vue?vue&type=script&lang=js"
export * from "./Cooperate.vue?vue&type=script&lang=js"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=5c24acd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24acd4",
  null
  
)

export default component.exports